export default __webpack_public_path__ + "static/media/menu-mobile.0776cac6.svg";